import { render, staticRenderFns } from "./PropertyFilter.vue?vue&type=template&id=8958e4fa&scoped=true&"
import script from "./PropertyFilter.vue?vue&type=script&lang=js&"
export * from "./PropertyFilter.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFilter.vue?vue&type=style&index=0&id=8958e4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8958e4fa",
  null
  
)

export default component.exports